/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2020-05-05 10:50
 */

 import EnumItem, {enumMixn} from "./enumItem";

 /**
  * 用户权限
  */
 let EnumPermission = {
     1             : new EnumItem('管理员', 1),
     2               : new EnumItem('普通用户', 2),
     ...enumMixn
 }
 export default EnumPermission
 